import { useRouter } from 'next/router';

export const useSearchRoute = () => {
  const { query } = useRouter();

  if (query.searchquery) {
    return (query.searchquery as string).replace(/\+/g, ' ');
  }

  return null;
};
